import { render, staticRenderFns } from "./EditOption.vue?vue&type=template&id=4f871b74"
import script from "./EditOption.vue?vue&type=script&lang=ts"
export * from "./EditOption.vue?vue&type=script&lang=ts"
import style0 from "./EditOption.vue?vue&type=style&index=0&id=4f871b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports